import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Personalizer from 'personalizer';
import DateFormatter from 'utils/date/DateFormatter';
import DateParser from 'utils/date/DateParser';
import RankingUtil from 'utils/RankingUtil';
import NavigationUtil from 'utils/NavigationUtil';
import templateHtml from 'templates/notification/PendingCommentItemView.html';
import 'styles/settings.page.module.css';

import Notification from 'models/notification/Notification';
import { parseMessageFormatEnding } from './messageEndingHelper';

export var GENERIC_NOTIFICATION_TYPES = {
    COMMENTED_ON_USER_ACTIVITY: 'COMMENTED_ON_USER_ACTIVITY',
    COMMENTED_ON_USER_SEGMENT: 'COMMENTED_ON_USER_SEGMENT',
    LEADERBOARD_EARN_FIRST_PLACE: 'LEADERBOARD_EARN_FIRST_PLACE',
    LEADERBOARD_LOSE_FIRST_PLACE: 'LEADERBOARD_LOSE_FIRST_PLACE',
    FAVORITE_SEGMENT_DELETED: 'FAVORITE_SEGMENT_DELETED',
    FAVORITE_SEGMENT_EDITED: 'FAVORITE_SEGMENT_EDITED',
    COMMENTED_ON_USER_DAILYSUMMARY: 'COMMENTED_ON_USER_DAILYSUMMARY',
    COMMENTED_ON_USER_AUTOCHALLENGE: 'COMMENTED_ON_USER_AUTOCHALLENGE',
    COMMENTED_ON_ACTIVITY_THREAD: 'COMMENTED_ON_ACTIVITY_THREAD',
    AUTO_CHALLENGE_WINNER: 'AUTO_CHALLENGE_WINNER',
    ALSO_COMMENTED_ON_USER_SEGMENT: 'ALSO_COMMENTED_ON_USER_SEGMENT',
    ALSO_COMMENTED_ON_USER_DAILYSUMMARY: 'ALSO_COMMENTED_ON_USER_DAILYSUMMARY',
    CONNECTION_REQUEST_ACCEPTED: 'CONNECTION_REQUEST_ACCEPTED',
    LIKED_ON_ACTIVITY: 'LIKED_ON_ACTIVITY',
    LIKED_ON_ACTIVITY_COMMENT: 'LIKED_ON_ACTIVITY_COMMENT',
    TAGGED_ON_ACTIVITY_COMMENT: 'TAGGED_ON_ACTIVITY_COMMENT',
    GROUP_NEWS_POST: 'GROUP_NEWS_POST',
    GROUP_ANNOUNCEMENT: 'GROUP_ANNOUNCEMENT',
    COMMENTED_ON_GROUP_NEWS_POST: 'COMMENTED_ON_GROUP_NEWS_POST',
    ALSO_COMMENTED_ON_GROUP_NEWS_POST: 'ALSO_COMMENTED_ON_GROUP_NEWS_POST',
    LIKED_ON_GROUP_POST: 'LIKED_ON_GROUP_POST',
    LIKED_ON_GROUP_POST_COMMENT: 'LIKED_ON_GROUP_POST_COMMENT',
    COMMENTED_ON_GROUP_ACTIVITY: 'COMMENTED_ON_GROUP_ACTIVITY',
    ALSO_COMMENTED_ON_GROUP_ACTIVITY: 'ALSO_COMMENTED_ON_GROUP_ACTIVITY',
    LIKED_ON_GROUP_ACTIVITY: 'LIKED_ON_GROUP_ACTIVITY',
    LIKED_ON_GROUP_ACTIVITY_COMMENT: 'LIKED_ON_GROUP_ACTIVITY_COMMENT',
    GROUP_INVITE_ACCEPTED: 'GROUP_INVITE_ACCEPTED',
    PRIVATE_GROUP_REQUEST_ACCEPTED: 'PRIVATE_GROUP_REQUEST_ACCEPTED',
    WEIGHT_SCALE_REMOVED: 'WEIGHT_SCALE_REMOVED',
    WEIGHT_SCALE_MAX_USER: 'WEIGHT_SCALE_MAX_USER',
    DEVICE_REMOVED: 'DEVICE_REMOVED',
    DEVICE_MAX_USER: 'DEVICE_MAX_USER',
    INACTIVE_ACTIVITY_TRACKER_USED: 'INACTIVE_ACTIVITY_TRACKER_USED',
    GEAR_MAX_DISTANCE: 'GEAR_MAX_DISTANCE',
    GROUP_CHALLENGE_CREATED: 'GROUP_CHALLENGE_CREATED',
    GROUP_CHALLENGE_START: 'GROUP_CHALLENGE_START',
    GROUP_CHALLENGE_OVER: 'GROUP_CHALLENGE_OVER',
    GROUP_CHALLENGE_BADGE: 'GROUP_CHALLENGE_BADGE',

    ADHOC_CHALLENGE_INVITED: 'ADHOC_CHALLENGE_INVITED',
    ADHOC_CHALLENGE_ACCEPTED: 'ADHOC_CHALLENGE_ACCEPTED',
    ADHOC_CHALLENGE_DECLINED: 'ADHOC_CHALLENGE_DECLINED',
    ADHOC_CHALLENGE_START: 'ADHOC_CHALLENGE_START',
    ADHOC_CHALLENGE_INVITE_WILL_EXPIRE: 'ADHOC_CHALLENGE_INVITE_WILL_EXPIRE',
    ADHOC_CHALLENGE_START_TOMORROW: 'ADHOC_CHALLENGE_START_TOMORROW',
    ADHOC_CHALLENGE_SUMMARY: 'ADHOC_CHALLENGE_SUMMARY',
    CHALLENGE_RANKING_UP: 'CHALLENGE_RANKING_UP',
    CHALLENGE_RANKING_TAKEN: 'CHALLENGE_RANKING_TAKEN',
    CHALLENGE_RANKING_DOWN: 'CHALLENGE_RANKING_DOWN',
    ADHOC_CHALLENGE_ENDING_SOON: 'ADHOC_CHALLENGE_ENDING_SOON',
    ADHOC_CHALLENGE_ENDED: 'ADHOC_CHALLENGE_ENDED',
    ADHOC_CHALLENGE_FIRST_PLACE: 'ADHOC_CHALLENGE_FIRST_PLACE',
    ADHOC_CHALLENGE_NOT_FIRST_PLACE: 'ADHOC_CHALLENGE_NOT_FIRST_PLACE',
    ADHOC_CHALLENGE_ALTERNATE_PRIZE: 'ADHOC_CHALLENGE_ALTERNATE_PRIZE',
    COMMENTED_ON_ADHOC_CHALLENGE: 'COMMENTED_ON_ADHOC_CHALLENGE',

    VVFJR_ADHOC_CHALLENGE_INVITED: 'VVFJR_ADHOC_CHALLENGE_INVITED',
    VVFJR_ADHOC_CHALLENGE_START: 'VVFJR_ADHOC_CHALLENGE_START',
    VVFJR_CHALLENGE_INVITE_WILL_EXPIRE: 'VVFJR_CHALLENGE_INVITE_WILL_EXPIRE',
    VVFJR_ADHOC_CHALLENGE_START_TOMORROW: 'VVFJR_ADHOC_CHALLENGE_START_TOMORROW',
    VVFJR_CHALLENGE_ENDING_SOON: 'VVFJR_CHALLENGE_ENDING_SOON',
    VVFJR_CHALLENGE_END: 'VVFJR_CHALLENGE_END',
    VVFJR_ADHOC_CHALLENGE_FIRST_PLACE: 'VVFJR_ADHOC_CHALLENGE_FIRST_PLACE',
    VVFJR_CHALLENGE_NOT_FIRST_PLACE: 'VVFJR_CHALLENGE_NOT_FIRST_PLACE',
    VVFJR_COMMENTED_ON_CHALLENGE: 'VVFJR_COMMENTED_ON_CHALLENGE',

    VVFJR_TEAM_CHALLENGE_INVITED: 'VVFJR_TEAM_CHALLENGE_INVITED',
    VVFJR_TEAM_CHALLENGE_ACCEPTED: 'VVFJR_TEAM_CHALLENGE_ACCEPTED',
    VVFJR_TEAM_CHALLENGE_DECLINED: 'VVFJR_TEAM_CHALLENGE_DECLINED',
    VVFJR_TEAM_CHALLENGE_START: 'VVFJR_TEAM_CHALLENGE_START',
    VVFJR_TEAM_CHALLENGE_INVITE_WILL_EXPIRE: 'VVFJR_TEAM_CHALLENGE_INVITE_WILL_EXPIRE',
    VVFJR_TEAM_CHALLENGE_START_TOMORROW: 'VVFJR_TEAM_CHALLENGE_START_TOMORROW',
    VVFJR_TEAM_CHALLENGE_SUMMARY: 'VVFJR_TEAM_CHALLENGE_SUMMARY',
    VVFJR_TEAM_CHALLENGE_ENDING_SOON: 'VVFJR_TEAM_CHALLENGE_ENDING_SOON',
    VVFJR_TEAM_CHALLENGE_ENDED: 'VVFJR_TEAM_CHALLENGE_ENDED',
    VVFJR_TEAM_CHALLENGE_FIRST_PLACE: 'VVFJR_TEAM_CHALLENGE_FIRST_PLACE',
    VVFJR_TEAM_CHALLENGE_NOT_FIRST_PLACE: 'VVFJR_TEAM_CHALLENGE_NOT_FIRST_PLACE',
    VVFJR_TEAM_CHALLENGE_ALTERNATE_PRIZE: 'VVFJR_TEAM_CHALLENGE_ALTERNATE_PRIZE',
    VVFJR_COMMENTED_ON_TEAM_CHALLENGE: 'VVFJR_COMMENTED_ON_TEAM_CHALLENGE',
    VVFJR_TEAM_CHALLENGE_END: 'VVFJR_TEAM_CHALLENGE_END',
    VVFJR_TEAM_CHALLENGE_ENDS_IN_A_TIE: 'VVFJR_TEAM_CHALLENGE_ENDS_IN_A_TIE',
    SHAREABLE_DEVICE_ACCEPT: 'SHAREABLE_DEVICE_ACCEPT',
    PRIVATE_GROUP_REQUEST_ACCEPTED: 'PRIVATE_GROUP_REQUEST_ACCEPTED',

    SHAREABLE_EVENT_DELETED: 'SHAREABLE_EVENT_DELETED',
    SHAREABLE_EVENT_COURSE_UPDATED: 'SHAREABLE_EVENT_COURSE_UPDATED',
    SHAREABLE_EVENT_UPDATED: 'SHAREABLE_EVENT_UPDATED',
    SHAREABLE_EVENT_PACEPRO_RECREATE: 'SHAREABLE_EVENT_PACEPRO_RECREATE',
    SHAREABLE_EVENT_POWERGUIDE_RECREATE: 'SHAREABLE_EVENT_POWERGUIDE_RECREATE',
    SHAREABLE_EVENT_POWERGUIDE_REMOVED: 'SHAREABLE_EVENT_POWERGUIDE_REMOVED',
    SHAREABLE_EVENT_PACEPRO_REMOVED: 'SHAREABLE_EVENT_PACEPRO_REMOVED',

    ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS: 'ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS',
    ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE: 'ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE',
    ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS: 'ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS',
    ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE: 'ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE',

    TRAINING_NEW_PREMIUM_CONTENT: 'TRAINING_NEW_PREMIUM_CONTENT'
};

const SHAREABLE_EVENT_FIELDS = {
    EVENT_DATE: 'shareable_event_date',
    EVENT_TYPE: 'shareable_event_type',
    EVENT_LOCATION: 'shareable_event_location',
    EVENT_TIME: 'shareable_event_start_time',
    EVENT_WEBSITE: 'shareable_event_website',
    EVENT_NOTES: 'shareable_event_notes',
    EVENT_NAME: 'shareable_event_name'
};

var Events = {
    COMMENT_CLICKED: 'COMMENT_CLICKED',
    NOTIFICATION_DISMISSED: 'NOTIFICATION_DISMISSED',
    NOTIFICATION_DISMISS_UNDO_SUCCESS: 'NOTIFICATION_DISMISS_UNDO_SUCCESS',
    NOTIFICATION_DISMISS_UNDO_FAIL: 'NOTIFICATION_DISMISS_UNDO_FAIL'
};

const END_MESSAGE_RULES = {
    ADHOC_CHALLENGE_ACCEPTED: () => '',
    ADHOC_CHALLENGE_SUMMARY: (pendingComment) => {
        if (
            typeof pendingComment !== 'undefined' &&
            pendingComment !== null &&
            typeof pendingComment.relativeNameValue !== 'undefined' &&
            pendingComment.relativeNameValue !== null &&
            typeof pendingComment.relativeNameValue.from_user_name !== 'undefined' &&
            pendingComment.relativeNameValue.from_user_name !== null &&
            typeof pendingComment.relativeNameValue.format_id !== 'undefined' &&
            pendingComment.relativeNameValue.format_id !== null
        ) {
            let format_id = Number(pendingComment.relativeNameValue.format_id) % 5;
            return format_id <= 1 ? '_single' : `_single_${format_id}`;
        }
        return '';
    }
};

var PendingCommentItemView = Backbone.View.extend({
    events: {
        'click .js-select-comment': 'onCommentClicked',
        'click .js-dismiss-button': 'onDismissClicked',
        'click .js-undo-button': 'onUndoClicked'
    },

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.pendingComment = args.pendingComment;
        this.viewerDisplayName = args.displayName;
        this.addToList = args.addToList;
        this.removeFromList = args.removeFromList;
        this.trainingPlans = args.trainingPlans?.toJSON();
        this.hideItem = false; // hide specific item
    },

    render: function() {
        this.buildCommentMessage();

        if (this.hideItem) {
            return;
        }

        this.$el.append(
            this.template({
                Localizer: Localizer,
                Personalizer: Personalizer,
                pendingComment: this.pendingComment,
                commentUrl: NavigationUtil.url(this.pendingComment.relativeUrl)
            })
        );
    },

    buildCommentMessage: function() {
        this.pendingComment.numberOfDaysAgo = this.formatMessageDate();

        var commentName = _.escape(
            this.pendingComment.fullName !== null ? this.pendingComment.fullName : this.pendingComment.displayName
        );
        var name = _.escape(this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.name : null);
        var activityName = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.act_name : null
        );
        var activityOwnerName = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.act_owner_name : null
        );
        var segmentName = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.seg_name : null
        );
        var dailySummaryOwnerName = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.well_owner_name : null
        );
        var groupName = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.group_name : null
        );
        const groupPostText = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.newspost_text : null
        );
        const groupAnnouncementText = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.announcement_text : null
        );
        var fromUsername = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.from_user_name : null
        );
        var vivoFitJrTeamChallengeName = _.escape(
            this.pendingComment.relativeNameValue
                ? this.pendingComment.relativeNameValue.vivokid_team_challenge_name
                : null
        );
        let commentText = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.comment_text : null
        );
        const eventName = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.event_name : null
        );
        var messageEnding = this.getMessageFormatEnding();

        var type = this.pendingComment.type;
        var segmentImage = '/resource/ui/images/segment-notifications.png';

        switch (type) {
            case GENERIC_NOTIFICATION_TYPES.ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS:
                let privacyChangedTo =
                    this.pendingComment.relativeNameValue && this.pendingComment.relativeNameValue.privacy_setting
                        ? Localizer.localize(`privacy.${this.pendingComment.relativeNameValue.privacy_setting}.title`)
                        : '';
                this.pendingComment.formatComment = Localizer.localize(
                    'all_past_activities_privacy_update_success',
                    privacyChangedTo
                );
                this.pendingComment.relativeUrl = '#';
                break;
            case GENERIC_NOTIFICATION_TYPES.ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE:
                let privacyFailChangedTo =
                    this.pendingComment.relativeNameValue && this.pendingComment.relativeNameValue.privacy_setting
                        ? Localizer.localize(`privacy.${this.pendingComment.relativeNameValue.privacy_setting}.title`)
                        : '';
                this.pendingComment.formatComment = Localizer.localize(
                    'all_past_activities_privacy_update_error',
                    privacyFailChangedTo
                );
                this.pendingComment.relativeUrl = 'settings/privacySettings?pastActivityPrivacy=true';
                break;
            case GENERIC_NOTIFICATION_TYPES.ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS:
                let values = this.getAllActivitiesNamesList(this.pendingComment);
                this.pendingComment.formatComment = Localizer.localize(
                    'specific_past_activities_privacy_update_success',
                    values
                );
                this.pendingComment.relativeUrl = '#';
                break;
            case GENERIC_NOTIFICATION_TYPES.ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE:
                this.pendingComment.formatComment = Localizer.localize('specific_past_activities_privacy_update_error');
                this.pendingComment.relativeUrl = 'settings/privacySettings?pastActivityPrivacy=true';
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_USER_SEGMENT:
                this.pendingComment.formatComment = Localizer.localize('segment.comment', commentName);
                this.pendingComment.relativeUrl = this.buildSegmentUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_USER_ACTIVITY:
                this.pendingComment.formatComment = commentText
                    ? Localizer.localize('commented.your.activity.with.comment', commentName, commentText)
                    : Localizer.localize('activity.comment', commentName);
                this.pendingComment.relativeUrl = this.buildActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_USER_DAILYSUMMARY:
                this.pendingComment.formatComment = Localizer.localize('daily.summary.comment', commentName);
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_USER_AUTOCHALLENGE:
                this.pendingComment.formatComment = Localizer.localize(
                    'auto.challenge.comment',
                    commentName,
                    this.getChallengeName(this.pendingComment)
                );
                this.pendingComment.relativeUrl = this.buildAutoChallengeUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_ACTIVITY_THREAD:
                if (activityName) {
                    this.pendingComment.formatComment = commentText
                        ? Localizer.localize(
                              'also.commented.your.named.activity.with.comment',
                              commentName,
                              activityName,
                              commentText
                          )
                        : Localizer.localize('activity.thread.comment', commentName, activityName);
                } else {
                    this.pendingComment.formatComment = Localizer.localize(
                        'also_commented_on_an_activity',
                        commentName,
                        commentText
                    );
                }
                this.pendingComment.relativeUrl = this.buildActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.ALSO_COMMENTED_ON_USER_SEGMENT:
                this.pendingComment.formatComment = Localizer.localize(
                    'segment.thread.comment',
                    commentName,
                    segmentName
                );
                this.pendingComment.relativeUrl = this.buildSegmentUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.ALSO_COMMENTED_ON_USER_DAILYSUMMARY:
                this.pendingComment.formatComment = Localizer.localize(
                    'daily.summary.thread.comment',
                    commentName,
                    dailySummaryOwnerName
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.AUTO_CHALLENGE_WINNER:
                this.pendingComment.formatComment = Localizer.localize('autochallenge.last.week.subject', commentName);
                this.pendingComment.relativeUrl = '/auto-challenge/previous';
                break;
            case GENERIC_NOTIFICATION_TYPES.LEADERBOARD_EARN_FIRST_PLACE:
                this.pendingComment.formatComment = Localizer.localize('segment.leaderboard_earn_first_place', name);
                this.pendingComment.imageUrl = segmentImage;
                this.pendingComment.relativeUrl = this.buildSegmentUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.LEADERBOARD_LOSE_FIRST_PLACE:
                this.pendingComment.formatComment = Localizer.localize('segment.leaderboard_lost_first_place', name);
                this.pendingComment.imageUrl = segmentImage;
                this.pendingComment.relativeUrl = this.buildSegmentUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.FAVORITE_SEGMENT_DELETED:
                this.pendingComment.preventClick = true;
                this.pendingComment.formatComment = Localizer.localize('segment.favorite_segment_deleted', name);
                this.pendingComment.imageUrl = segmentImage;
                this.pendingComment.relativeUrl = '#';
                break;
            case GENERIC_NOTIFICATION_TYPES.FAVORITE_SEGMENT_EDITED:
                this.pendingComment.formatComment = Localizer.localize('segment.favorite_segment_edited', name);
                this.pendingComment.imageUrl = segmentImage;
                this.pendingComment.relativeUrl = this.buildSegmentUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.GROUP_NEWS_POST:
                if (groupPostText) {
                    this.pendingComment.formatComment = Localizer.localize(
                        'group.create.post.with.text',
                        commentName,
                        groupName,
                        groupPostText
                    );
                } else {
                    this.pendingComment.formatComment = Localizer.localize('group.post', commentName, groupName);
                }
                this.pendingComment.relativeUrl = this.buildGroupNewsPostUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.GROUP_ANNOUNCEMENT:
                this.pendingComment.formatComment = Localizer.localize(
                    'new_group_announcement_with_text',
                    commentName,
                    groupName,
                    groupAnnouncementText
                );
                this.pendingComment.relativeUrl = `${this.buildGroupUrl(this.pendingComment)}/checkAnnouncement`;
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_GROUP_NEWS_POST:
                this.pendingComment.formatComment = Localizer.localize(
                    'group.comment.my.post.with.text',
                    commentName,
                    groupName,
                    commentText
                );
                this.pendingComment.relativeUrl = this.buildGroupNewsPostUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.ALSO_COMMENTED_ON_GROUP_NEWS_POST:
                this.pendingComment.formatComment = Localizer.localize(
                    'group.also.comment.on.other.post',
                    commentName,
                    groupName,
                    commentText
                );
                this.pendingComment.relativeUrl = this.buildGroupNewsPostUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.LIKED_ON_GROUP_POST:
                if (groupPostText) {
                    this.pendingComment.formatComment = Localizer.localize(
                        'liked.your.group.post',
                        commentName,
                        groupName,
                        groupPostText
                    );
                } else {
                    this.pendingComment.formatComment = Localizer.localize(
                        'liked_your_post_subject',
                        commentName,
                        groupName
                    );
                }
                this.pendingComment.relativeUrl = this.buildGroupNewsPostUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.LIKED_ON_GROUP_POST_COMMENT:
                this.pendingComment.formatComment = Localizer.localize(
                    'liked.your.group.comment',
                    commentName,
                    groupName,
                    commentText
                );
                this.pendingComment.relativeUrl = this.buildGroupNewsPostUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_GROUP_ACTIVITY:
                this.pendingComment.formatComment = Localizer.localize(
                    'commented.your.group.activity.with.comment',
                    commentName,
                    groupName,
                    commentText
                );
                this.pendingComment.relativeUrl = this.buildGroupActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.ALSO_COMMENTED_ON_GROUP_ACTIVITY:
                if (activityName) {
                    this.pendingComment.formatComment = Localizer.localize(
                        'also.commented.group.named.activity',
                        commentName,
                        activityName,
                        groupName,
                        commentText
                    );
                } else {
                    this.pendingComment.formatComment = Localizer.localize(
                        'also.commented.group.untitled.activity',
                        commentName,
                        groupName,
                        commentText
                    );
                }
                this.pendingComment.relativeUrl = this.buildGroupActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.LIKED_ON_GROUP_ACTIVITY:
                this.pendingComment.formatComment = Localizer.localize(
                    'liked.your.group.activity',
                    commentName,
                    groupName
                );
                this.pendingComment.relativeUrl = this.buildGroupActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.LIKED_ON_GROUP_ACTIVITY_COMMENT:
                this.pendingComment.formatComment = Localizer.localize(
                    'liked.your.group.comment',
                    commentName,
                    groupName,
                    commentText
                );
                this.pendingComment.relativeUrl = this.buildGroupActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.CONNECTION_REQUEST_ACCEPTED:
                this.pendingComment.formatComment = Localizer.localize('is_your_connection', commentName);
                this.pendingComment.relativeUrl = this.buildUserProfileUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.LIKED_ON_ACTIVITY:
                let activityNameForLike = activityName || Localizer.localize('untitled');
                this.pendingComment.formatComment = Localizer.localize(
                    'liked.your.named.activity',
                    commentName,
                    activityNameForLike
                );
                this.pendingComment.relativeUrl = this.buildActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.LIKED_ON_ACTIVITY_COMMENT:
                this.pendingComment.formatComment = Localizer.localize(
                    'liked.your.comment.with.content',
                    commentName,
                    commentText
                );
                this.pendingComment.relativeUrl = this.buildActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.TAGGED_ON_ACTIVITY_COMMENT:
                this.pendingComment.formatComment = Localizer.localize(
                    'tagged_you_in_comment',
                    commentName,
                    commentText
                );
                this.pendingComment.relativeUrl = this.buildActivityUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.GROUP_INVITE_ACCEPTED:
                this.pendingComment.formatComment = Localizer.localize('group.invite.accepted', commentName, groupName);
                this.pendingComment.relativeUrl = this.buildGroupUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.PRIVATE_GROUP_REQUEST_ACCEPTED:
                this.pendingComment.formatComment = Localizer.localize(
                    'group.admin.accepted.2',
                    commentName,
                    groupName
                );
                this.pendingComment.relativeUrl = this.buildGroupUrl(this.pendingComment);
                break;
            case GENERIC_NOTIFICATION_TYPES.INACTIVE_ACTIVITY_TRACKER_USED:
                var devicesLink = Localizer.localize('devices.link');
                devicesLink = "<a class='colored' href='/devices'>" + devicesLink + '</a>';
                this.pendingComment.formatComment = Localizer.localize(
                    'activity.tracker.data.not.synced.message',
                    this.getDeviceName(this.pendingComment),
                    devicesLink
                );
                this.pendingComment.relativeUrl = '/devices';
                break;
            case GENERIC_NOTIFICATION_TYPES.GEAR_MAX_DISTANCE:
                this.pendingComment.formatComment = Localizer.localize(
                    'gear.max.distance.met.email.subject',
                    this.getGearName(this.pendingComment)
                );
                this.pendingComment.relativeUrl = '/gear';
                break;
            case GENERIC_NOTIFICATION_TYPES.GROUP_CHALLENGE_CREATED:
                this.pendingComment.formatComment = Localizer.localize(
                    'group.challenge.created',
                    groupName,
                    this.getGroupChallengeName(),
                    this.getGroupChallengeStartDate()
                );
                this.pendingComment.relativeUrl = this.getGroupChallengeUrl();
                break;
            case GENERIC_NOTIFICATION_TYPES.GROUP_CHALLENGE_START:
                this.pendingComment.formatComment = Localizer.localize(
                    'group.challenge.start',
                    groupName,
                    this.getGroupChallengeName()
                );
                this.pendingComment.relativeUrl = this.getGroupChallengeUrl();
                break;
            case GENERIC_NOTIFICATION_TYPES.GROUP_CHALLENGE_OVER:
                this.pendingComment.formatComment = Localizer.localize(
                    'group.challenge.over',
                    this.getRank(),
                    groupName,
                    this.getGroupChallengeName()
                );
                this.pendingComment.relativeUrl = this.getGroupChallengeUrl();
                break;
            case GENERIC_NOTIFICATION_TYPES.GROUP_CHALLENGE_BADGE:
                this.pendingComment.formatComment = Localizer.localize(
                    'group.challenge.badge',
                    this.getRank(),
                    groupName,
                    this.getGroupChallengeName()
                );
                this.pendingComment.relativeUrl = '/badges';
                break;
            case GENERIC_NOTIFICATION_TYPES.WEIGHT_SCALE_REMOVED:
                var deviceName = this.getDeviceName(this.pendingComment);
                const key = deviceName ? 'device.has.removed.notification' : 'weight.scale.has.removed.notification';
                this.pendingComment.formatComment = Localizer.localize(key, commentName, deviceName);
                this.pendingComment.relativeUrl = '/devices';
                break;
            case GENERIC_NOTIFICATION_TYPES.WEIGHT_SCALE_MAX_USER:
                var deviceName = this.getDeviceName(this.pendingComment);
                var deviceUrl = this.buildDeviceUrl(this.pendingComment);
                if (deviceName) {
                    this.pendingComment.formatComment = Localizer.localize(
                        'device.max.user.notification',
                        commentName,
                        deviceName,
                        deviceUrl
                    );
                } else {
                    this.pendingComment.formatComment = Localizer.localize(
                        'weight.scale.max.user.notification',
                        commentName,
                        deviceUrl
                    );
                }
                this.pendingComment.relativeUrl = deviceUrl;
                break;
            case GENERIC_NOTIFICATION_TYPES.DEVICE_REMOVED:
                this.pendingComment.formatComment = Localizer.localize(
                    'device.has.removed.notification',
                    commentName,
                    this.getDeviceName(this.pendingComment)
                );
                this.pendingComment.relativeUrl = '/devices';
                break;
            case GENERIC_NOTIFICATION_TYPES.DEVICE_MAX_USER:
                var deviceUrl = this.buildDeviceUrl(this.pendingComment);
                this.pendingComment.formatComment = Localizer.localize(
                    'device.max.user.notification',
                    commentName,
                    this.getDeviceName(this.pendingComment),
                    deviceUrl
                );
                this.pendingComment.relativeUrl = deviceUrl;
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_DEVICE_ACCEPT:
                var deviceUrl = this.buildDeviceUrl(this.pendingComment) + '/users';
                this.pendingComment.formatComment = Localizer.localize(
                    'invitation_to_device_accepted_notification',
                    commentName,
                    this.getDeviceName(this.pendingComment)
                );
                this.pendingComment.relativeUrl = deviceUrl;
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_ACCEPTED:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_accepted_format' + messageEnding,
                    fromUsername
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_DECLINED:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_declined_format' + messageEnding,
                    fromUsername
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_START:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_start_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_ADHOC_CHALLENGE_START:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_start_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_INVITE_WILL_EXPIRE:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_invite_will_expire_format' + messageEnding,
                    fromUsername
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_CHALLENGE_INVITE_WILL_EXPIRE:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_invite_will_expire_format' + messageEnding,
                    fromUsername
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_START_TOMORROW:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_start_tomorrow_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_ADHOC_CHALLENGE_START_TOMORROW:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_start_tomorrow_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_SUMMARY:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                if (
                    typeof this.pendingComment.relativeNameValue !== 'undefined' &&
                    this.pendingComment.relativeNameValue !== null &&
                    typeof this.pendingComment.relativeNameValue.from_user_name !== 'undefined' &&
                    this.pendingComment.relativeNameValue.from_user_name !== null &&
                    typeof this.pendingComment.relativeNameValue.format_id !== 'undefined' &&
                    this.pendingComment.relativeNameValue.format_id !== null
                ) {
                    this.pendingComment.formatComment = Localizer.localize(
                        'pn_adhoc_challenge_summary_format' + messageEnding,
                        this.pendingComment.relativeNameValue.from_user_name
                    );
                } else {
                    this.pendingComment.formatComment = Localizer.localize(
                        'pn_adhoc_challenge_summary_format' + messageEnding
                    );
                }
                break;
            case GENERIC_NOTIFICATION_TYPES.CHALLENGE_RANKING_UP:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                var name = _.escape(
                    this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.name : null
                );
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_rank_up_format' + messageEnding,
                    name
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.CHALLENGE_RANKING_TAKEN:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                var name = _.escape(
                    this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.name : null
                );
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_rank_taken_format' + messageEnding,
                    name
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.CHALLENGE_RANKING_DOWN:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                var name = _.escape(
                    this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.name : null
                );
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_rank_down_format' + messageEnding,
                    name
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_ENDING_SOON:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_ending_soon_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_CHALLENGE_ENDING_SOON:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_ending_soon_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_ENDED:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_ended_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_CHALLENGE_END:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_ended_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_FIRST_PLACE:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_first_place_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_ADHOC_CHALLENGE_FIRST_PLACE:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_first_place_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_NOT_FIRST_PLACE:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_not_first_place_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_CHALLENGE_NOT_FIRST_PLACE:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_not_first_place_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_ALTERNATE_PRIZE:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_alternate_prize_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.COMMENTED_ON_ADHOC_CHALLENGE:
                this.pendingComment.relativeUrl = this.getChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize('pn_commented_on_adhoc_challenge', commentName);
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_COMMENTED_ON_CHALLENGE:
                this.pendingComment.relativeUrl = this.getVivofitjrChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize('pn_commented_on_adhoc_challenge', commentName);
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_ACCEPTED:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_accepted_format' + messageEnding,
                    fromUsername
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_DECLINED:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_declined_format' + messageEnding,
                    fromUsername
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_START:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_start_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_INVITE_WILL_EXPIRE:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_invite_will_expire_format' + messageEnding,
                    fromUsername
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_START_TOMORROW:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_start_tomorrow_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_SUMMARY:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_summary_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_ENDING_SOON:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_ending_soon_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_ENDED:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_ended_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_FIRST_PLACE:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_first_place_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_NOT_FIRST_PLACE:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_not_first_place_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_ALTERNATE_PRIZE:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_alternate_prize_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_COMMENTED_ON_TEAM_CHALLENGE:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize('pn_commented_on_adhoc_challenge', commentName);
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_END:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = this.pendingComment.formatComment = Localizer.localize(
                    'pn_adhoc_challenge_ended_format' + messageEnding
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_ENDS_IN_A_TIE:
                this.pendingComment.relativeUrl = this.getVivofitjrTeamStepsChallengeUrl();
                this.pendingComment.formatComment = Localizer.localize(
                    'vivo_jr_tean_challenge_ended_as_tie',
                    vivoFitJrTeamChallengeName
                );
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_EVENT_DELETED:
                this.pendingComment.formatComment = Localizer.localize('shareable_event_deleted', eventName);
                this.pendingComment.relativeUrl = '/calendar';
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_EVENT_UPDATED:
                if (this.pendingComment.relativeNameValue) {
                    const shareableEventUuid = this.pendingComment.relativeNameValue.shareable_event_uuid;
                    this.pendingComment.relativeUrl = `/calendar?shareableEventUuid=${shareableEventUuid}`;
                    const modified_fields = this.pendingComment.relativeNameValue.modified_fields;
                    if (modified_fields.indexOf(',') > -1) {
                        this.pendingComment.formatComment = Localizer.localize(
                            'shareable_event_updated_multiple',
                            eventName
                        );
                    } else {
                        if (this.pendingComment.relativeNameValue.modified_fields === 'COMPLETION_TARGET') {
                            this.pendingComment.formatComment = Localizer.localize(
                                'shareable_event_updated_completion_target',
                                eventName
                            );
                        } else {
                            const modified_field = Localizer.localize(
                                SHAREABLE_EVENT_FIELDS[this.pendingComment.relativeNameValue.modified_fields]
                            );
                            this.pendingComment.formatComment = Localizer.localize(
                                'shareable_event_updated_single',
                                modified_field,
                                eventName
                            );
                        }
                    }
                } else {
                    this.pendingComment.relativeUrl = '/calendar';
                }
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_EVENT_COURSE_UPDATED:
                this.pendingComment.formatComment = Localizer.localize('shareable_event_course_updated', eventName);
                if (this.pendingComment.relativeNameValue) {
                    const shareableEventUuid = this.pendingComment.relativeNameValue.shareable_event_uuid;
                    this.pendingComment.relativeUrl = `/calendar?shareableEventUuid=${shareableEventUuid}`;
                } else {
                    this.pendingComment.relativeUrl = '/calendar';
                }
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_EVENT_PACEPRO_RECREATE:
                this.pendingComment.formatComment = Localizer.localize('shareable_event_pacepro_updated', eventName);
                if (this.pendingComment.relativeNameValue) {
                    const shareableEventUuid = this.pendingComment.relativeNameValue.shareable_event_uuid;
                    this.pendingComment.relativeUrl = `/calendar?shareableEventUuid=${shareableEventUuid}`;
                } else {
                    this.pendingComment.relativeUrl = '/calendar';
                }
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_EVENT_POWERGUIDE_RECREATE:
                this.pendingComment.formatComment = Localizer.localize(
                    'shareable_event_power_guide_updated',
                    eventName
                );
                if (this.pendingComment.relativeNameValue) {
                    const shareableEventUuid = this.pendingComment.relativeNameValue.shareable_event_uuid;
                    this.pendingComment.relativeUrl = `/calendar?shareableEventUuid=${shareableEventUuid}`;
                } else {
                    this.pendingComment.relativeUrl = '/calendar';
                }
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_EVENT_POWERGUIDE_REMOVED:
                this.pendingComment.formatComment = Localizer.localize(
                    'shareable_event_power_guide_updated_notification',
                    eventName
                );
                if (this.pendingComment.relativeNameValue) {
                    const shareableEventUuid = this.pendingComment.relativeNameValue.shareable_event_uuid;
                    this.pendingComment.relativeUrl = `/calendar?shareableEventUuid=${shareableEventUuid}`;
                } else {
                    this.pendingComment.relativeUrl = '/calendar';
                }
                break;
            case GENERIC_NOTIFICATION_TYPES.SHAREABLE_EVENT_PACEPRO_REMOVED:
                this.pendingComment.formatComment = Localizer.localize(
                    'shareable_event_pacepro_updated_notification',
                    eventName
                );
                if (this.pendingComment.relativeNameValue) {
                    const shareableEventUuid = this.pendingComment.relativeNameValue.shareable_event_uuid;
                    this.pendingComment.relativeUrl = `/calendar?shareableEventUuid=${shareableEventUuid}`;
                } else {
                    this.pendingComment.relativeUrl = '/calendar';
                }
                break;
            case GENERIC_NOTIFICATION_TYPES.TRAINING_NEW_PREMIUM_CONTENT:
                const TRAINING_TYPE_MAP = {
                    CYCLING_COACH: Localizer.localize('activity_type_cycling'),
                    RUN_COACH: Localizer.localize('label_run')
                };

                const trainingPlanId = this.pendingComment.relativeNameValue['training-plan-id'];
                if (this.trainingPlans?.some((plan) => plan?.trainingPlanId === Number(trainingPlanId))) {
                    const trainingType = TRAINING_TYPE_MAP[this.pendingComment.relativeNameValue['training-type']];
                    this.pendingComment.formatComment = Localizer.localize('new_training_guidance_indox', trainingType);
                    this.pendingComment.relativeUrl = `training/adaptive/details/${trainingPlanId}`;
                } else {
                    // this.trigger(Events.NOTIFICATION_FILTERED, this.pendingComment.notificationId);
                    //
                    // above action modifying source array, trigger another render, causing rendering a undefined item on the run time.
                    // might still need, but hide this item is safer for now.
                    this.hideItem = true;
                }
                break;
            default:
                if (console && console.log) {
                    console.log('Unexpected notification type: ' + type);
                }
        }
    },

    getMessageFormatEnding: function() {
        if (END_MESSAGE_RULES.hasOwnProperty(this.pendingComment.type)) {
            return END_MESSAGE_RULES[this.pendingComment.type](this.pendingComment);
        }

        const parsed = parseMessageFormatEnding(this.pendingComment);

        if (parsed) {
            return parsed;
        }

        var result = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.from_user_name : null
        );

        if (result && result > 1) {
            return '_' + result;
        }
        return '';
    },

    getChallengeUrl: function() {
        var challengeId = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.challenge_uuid : null
        );
        if (!challengeId) {
            challengeId = _.escape(
                this.pendingComment.relativeNameValue
                    ? this.pendingComment.relativeNameValue.adhoc_challenge_uuid
                    : null
            );
        }
        return '/adhoc-challenge/' + challengeId;
    },

    getAllActivitiesNamesList: function(notification) {
        let values = '';
        if (notification.relativeNameValue && Object.keys(notification.relativeNameValue).length) {
            let objectKeys = Object.keys(notification.relativeNameValue);

            objectKeys.forEach((item, index) => {
                let objectValue = notification.relativeNameValue[item];

                if (index === 0) {
                    values = Localizer.localize(`activity_type_${objectValue}`);
                } else if (index < objectKeys.length - 1) {
                    values += ', ' + Localizer.localize(`activity_type_${objectValue}`);
                } else if (index === objectKeys.length - 1) {
                    values +=
                        ` ${Localizer.localize('and_separator')} ` + Localizer.localize(`activity_type_${objectValue}`);
                }
            });
        }
        return values;
    },

    getVivofitjrChallengeUrl: function() {
        var challengeId = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.challenge_uuid : null
        );
        if (!challengeId) {
            challengeId = _.escape(
                this.pendingComment.relativeNameValue
                    ? this.pendingComment.relativeNameValue.vivokid_adhoc_challenge_uuid
                    : null
            );
        }
        return '/vivofitjr-challenge/' + challengeId;
    },

    getVivofitjrTeamStepsChallengeUrl: function() {
        var challengeId = _.escape(
            this.pendingComment.relativeNameValue
                ? this.pendingComment.relativeNameValue.vivokid_team_challenge_uuid
                : null
        );
        //this is a fallback for when vivokid_team_challenge_uuid is missing - at the moment i dont have a replacement
        if (!challengeId) {
            challengeId = _.escape(
                this.pendingComment.relativeNameValue
                    ? this.pendingComment.relativeNameValue.vivokid_adhoc_challenge_uuid
                    : null
            );
        }
        return '/vivofitjr-teamchallenge/' + challengeId;
    },

    getGroupChallengeUrl: function() {
        var challengeId = this.pendingComment.relativeNameValue
            ? this.pendingComment.relativeNameValue.challengeId
            : null;
        var url = '/challenge';
        if (challengeId) {
            url += '/' + challengeId;
        }
        return url;
    },

    getRank: function() {
        var rank = this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.rank : null;
        return RankingUtil.getFormattedRanking(rank);
    },

    formatMessageDate: function() {
        var localDate = DateParser.parseISOUTC(this.pendingComment.dateTimeString);

        return DateFormatter.formatRelativeTime(localDate);
    },

    buildUserProfileUrl: function(notification) {
        var url = null;
        var displayName = notification.displayName;
        if (displayName) {
            url = '/profile/' + displayName;
        }
        return url;
    },

    buildSegmentUrl: function(notification) {
        var url = null;

        var nameValues = notification.relativeNameValue;
        if (nameValues && nameValues.segment) {
            url = '/segment/' + nameValues.segment;
        }

        return url;
    },

    buildActivityUrl: function(notification) {
        var url = null;
        var nameValues = notification.relativeNameValue;

        if (nameValues && nameValues.group) {
            url = '/group/' + nameValues.group;
        } else if (nameValues && nameValues.activity) {
            url = '/activity/' + nameValues.activity;

            if (nameValues.comment_uuid) {
                url += `?focusCommentId=${nameValues.comment_uuid}`;
            }
        }

        return url;
    },

    buildAutoChallengeUrl: function(notification) {
        var url = '/auto-challenge';
        var nameValues = notification.relativeNameValue;
        if (nameValues) {
            if (nameValues.chall_period) {
                url = '/auto-challenge/previous';
            }
        }

        return url;
    },

    buildGroupUrl: function(notification) {
        var url = null;
        var nameValues = notification.relativeNameValue;
        if (nameValues && nameValues.group) {
            url = '/group/' + nameValues.group;
        }
        return url;
    },

    buildDeviceUrl: function(notification) {
        var url = null;
        var nameValues = notification.relativeNameValue;
        if (nameValues && nameValues.device) {
            url = '/device/' + nameValues.device;
        }
        return url;
    },

    buildGroupNewsPostUrl: function(notification) {
        var url = null;
        var nameValues = notification.relativeNameValue;

        if (nameValues && nameValues.group && nameValues.newspost) {
            url = '/group/' + nameValues.group + '/newspost/' + nameValues.newspost;
        }
        if (nameValues && nameValues.comment_uuid) {
            url += '/comment/' + nameValues.comment_uuid.toUpperCase();
        }

        return url;
    },

    buildGroupActivityUrl: function(notification) {
        var url = null;
        var nameValues = notification.relativeNameValue;

        if (nameValues && nameValues.activity) {
            url = '/group/' + nameValues.group + '/activity/' + nameValues.activity;
        }
        if (nameValues && nameValues.comment_uuid) {
            url += '/comment/' + nameValues.comment_uuid.toUpperCase();
        }

        return url;
    },

    buildGearUrl: function(notification) {
        var url = '/gear';
        var nameValues = notification.relativeNameValue;
        if (nameValues && nameValues.gear_type) {
            url += '/' + nameValues.gear_type;
        }
        return url;
    },

    getChallengeName: function(notification) {
        var nameValues = notification.relativeNameValue;
        if (nameValues && nameValues.chall_level) {
            var level = nameValues.chall_level;
            var steps = nameValues.chall_steps;
            if (steps == 0) {
                return Localizer.localize('challenge_' + level);
            } else {
                return Localizer.localize('challenge_level', level);
            }
        }
        return '';
    },
    getDeviceName: function(notification) {
        return _.escape(notification.relativeNameValue ? notification.relativeNameValue.device_name : null);
    },
    getGearName: function(notification) {
        return _.escape(notification.relativeNameValue ? notification.relativeNameValue.gear_name : null);
    },

    getGroupChallengeTypeKey: function() {
        var groupChallengeType = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.group_challenge_type : null
        );
        var key = null;
        switch (groupChallengeType) {
            case '0':
                key = 'group.challenge.most.walking.distance';
                break;
            case '1':
                key = 'group.challenge.most.running.distance';
                break;
            case '2':
                key = 'group.challenge.most.cycling.distance';
                break;
            case '3':
                key = 'group.challenge.most.swimming.distance';
                break;
            case '4':
                key = 'group.challenge.most.steps.count';
                break;
            case '5':
                key = 'group.challenge.most.steps.distance';
                break;
            case '6':
                key = 'group.challenge.most.calories.burned';
                break;
            default:
                key = null;
        }
        return key;
    },

    getGroupChallengeMonthKey: function() {
        var groupChallengeGmt = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.start_time_gmt : null
        );
        var groupChallengeDate = new Date(Number(groupChallengeGmt));
        var groupChallengeMonth = groupChallengeDate.getMonth();
        if (groupChallengeMonth <= 9) {
            groupChallengeMonth = '0' + groupChallengeMonth;
        }
        var key = 'month.' + groupChallengeMonth;
        return key;
    },

    getGroupChallengeStartDate: function() {
        var groupChallengeStartGmt = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.start_time_gmt : null
        );
        var groupChallengeDate = new Date(Number(groupChallengeStartGmt));
        return DateFormatter.formatDate(groupChallengeDate);
    },

    getGroupChallengeName: function() {
        var groupChallengeName = _.escape(
            this.pendingComment.relativeNameValue ? this.pendingComment.relativeNameValue.group_challenge_name : null
        );
        return groupChallengeName;
    },

    onCommentClicked: function(e) {
        if (this.pendingComment.relativeUrl) {
            this.trigger(Events.COMMENT_CLICKED);
            NavigationUtil.navigate(this.pendingComment.relativeUrl, e);
        }
    },

    onDismissClicked: function(e) {
        e.preventDefault();
        let model = new Notification({
            notificationId: this.pendingComment.notificationId
        });
        model.save(
            { dismiss: true },
            {
                type: 'PUT',
                parse: false,
                success: () => {
                    this.trigger(Events.NOTIFICATION_DISMISS_UNDO_SUCCESS);
                },
                error: () => {
                    this.$('.undo-section').fadeOut();
                    clearTimeout(this.dismissTimer);
                    this.dismissTimer = null;
                    this.trigger(Events.NOTIFICATION_DISMISS_UNDO_FAIL);
                }
            }
        );

        this.$('.undo-section').fadeIn();

        const DISMISS_TIMEOUT = 5000;
        this.dismissTimer = setTimeout(() => {
            this.$el
                .addClass('fadeOut')
                .delay(600)
                .slideUp();
            this.trigger(Events.NOTIFICATION_DISMISSED, this.pendingComment.notificationId);
            this.removeFromList(this.pendingComment.notificationId);
        }, DISMISS_TIMEOUT);

        this.addToList(this.pendingComment.notificationId, () => this.clearTimerAndExecute());
    },

    clearTimerAndExecute: function() {
        if (this.dismissTimer) {
            clearTimeout(this.dismissTimer);
            this.dismissTimer = null;
            this.$el.slideUp();
            this.trigger(Events.NOTIFICATION_DISMISSED, this.pendingComment.notificationId);
        }
    },

    onUndoClicked: function(e) {
        e.preventDefault();
        this.$('.undo-section').fadeOut();
        clearTimeout(this.dismissTimer);
        this.dismissTimer = null;
        let model = new Notification({
            notificationId: this.pendingComment.notificationId
        });
        model.save(
            { dismiss: false },
            {
                type: 'PUT',
                parse: false,
                success: () => {
                    this.trigger(Events.NOTIFICATION_DISMISS_UNDO_SUCCESS);
                },
                error: () => {
                    this.trigger(Events.NOTIFICATION_DISMISS_UNDO_FAIL);
                }
            }
        );
        this.removeFromList(this.pendingComment.notificationId);
    }
});

PendingCommentItemView.Events = Events;
export default PendingCommentItemView;
